<template>
	<div class="row ml-2 mt-5 mr-3" style="max-width:1300px;">
		<div class="col-12">
			<HomePage v-if="this.$route.path == '/'" />
			<HomePage v-if="this.$route.path == '/HomePage'" />
			<Manageuser v-if="this.$route.path == '/Manageuser'" />
			<Managepromotion v-if="this.$route.path == '/Managepromotion'" />
			<Managepromotionadd v-if="this.$route.path == '/Managepromotionadd'" />
			<Managecredit v-if="this.$route.path == '/Managecredit'" />
			<Setupsender v-if="this.$route.path == '/Setupsender'" />
			<Setupsenderadd v-if="this.$route.path == '/Setupsenderadd'" />
			<Sendmessage v-if="this.$route.path == '/Sendmessage'" />
			<EditSendmessage v-if="this.$route.path == '/EditSendmessage'" />
			<EditSendmessagelist v-if="this.$route.path == '/EditSendmessagelist'" />
			<Messagereport v-if="this.$route.path == '/Messagereport'" />
			<Takeoutreport v-if="this.$route.path == '/Takeoutreport'" />
			<Topuplist v-if="this.$route.path == '/Topuplist'" />
			<Setuser v-if="this.$route.path == '/Setuser'" />
			<Setuseradd v-if="this.$route.path == '/Setuseradd'" />
			<Usagedata v-if="this.$route.path == '/Usagedata'" />
			<Bankstatement v-if="this.$route.path == '/Bankstatement'" />
			<Depositlist v-if="this.$route.path == '/Depositlist'" />
			<Buypackage v-if="this.$route.path == '/Buypackage'" />
			<AccountDeposit v-if="this.$route.path == '/AccountDeposit'" />
			<AddAccountDeposit v-if="this.$route.path == '/AddAccountDeposit'" />
			<RemainwaitConfirm v-if="this.$route.path == '/RemainwaitConfirm'" />
			<ListDeposit v-if="this.$route.path == '/ListDeposit'" />
			<Depositdemical v-if="this.$route.path == '/Depositdemical'" />
		</div>
	</div>
</template>

<script>
	import HomePage from '../views/HomePage'
	import Setupsender from '../views/Setupsender'
	import Setupsenderadd from '../views/Setupsenderadd'
	import Sendmessage from '../views/Sendmessage'
	import EditSendmessage from '../views/EditSendmessage'
	import EditSendmessagelist from '../views/EditSendmessagelist'
	import Messagereport from '../views/Messagereport'
	import Takeoutreport from '../views/Takeoutreport'
	import Topuplist from '../views/Topuplist'
	import Setuser from '../views/Setuser'
	import Setuseradd from '../views/Setuseradd'
	import Usagedata from '../views/Usagedata'
	import Manageuser from '../views/Manageuser'
	import Managepromotion from '../views/Managepromotion'
	import Managepromotionadd from '../views/Managepromotionadd'
	import Managecredit from '../views/Managecredit'
	import Bankstatement from '../views/Bankstatement'
	import Depositlist from '../views/Depositlist'
	import Buypackage from '../views/Buypackage'
	import AccountDeposit from '../views/AccountDeposit'
	import AddAccountDeposit from '../views/AddAccountDeposit'
	import RemainwaitConfirm from '../views/RemainwaitConfirm'
	import ListDeposit from '../views/ListDeposit'
	import Depositdemical from '../views/Depositdemical'
	import {mapGetters} from 'vuex'

	export default {
		computed: {
			...mapGetters({
				isLogin: 'isLogin',
				user: 'user',
				token: 'token',
			}),
		},
		components: {
			Setupsender,
			Setupsenderadd,
			Sendmessage,
			EditSendmessage,
			EditSendmessagelist,
			Messagereport,
			Takeoutreport,
			Topuplist,
			Setuser,
			Setuseradd,
			Usagedata,
			Manageuser,
			Managepromotion,
			Managepromotionadd,
			Managecredit,
			HomePage,
			Bankstatement,
			Depositlist,
			Buypackage,
			AccountDeposit,
			AddAccountDeposit,
			RemainwaitConfirm,
			ListDeposit,
			Depositdemical,
		},
		mounted() {
			let conthis = this
			if (conthis.user.user_group == 98) {
				if (conthis.$route.path != '/Manageuser' || conthis.$route.path != '/Managecredit' || conthis.$route.path != '/Usagedata') {
					conthis.$router.push('/Manageuser')
				}
			} else if (conthis.user.user_group == 1) {
				if (conthis.$route.path == '/Manageuser' || conthis.$route.path == '/Managecredit') {
					conthis.$router.push('/Setupsender')
				}
			}
		},
	}
</script>

<style></style>
